import { CommonModule } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, Input, OnInit, ViewChild } from '@angular/core';
import { AxsButtonComponent } from '@vanguard/axs-angular';
import { ModalFunctions } from '@vanguard/axs-core';
import { ContentService } from 'src/app/shared/services/content/content.service';
import { content } from 'src/assets/content/fallback-content';

import { GatekeeperService } from '../../shared/services/gatekeeper/gatekeeper.service';
import { PersistentStorageService } from '../../shared/services/persistent-storage/persistent-storage.service';

@Component({
  selector: 'introduction-modal',
  standalone: true,
  imports: [CommonModule, AxsButtonComponent],
  templateUrl: './introduction-modal.component.html',
  styleUrls: ['./introduction-modal.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class IntroductionModalComponent implements OnInit {
  @Input() cookieName = 'FAS_RCC_Pref';
  @Input() flagName = 'introductionModal';

  @ViewChild('modal') modal: any;
  @ViewChild('dialog') dialog: any;

  showModal = false;
  activeSlide = 0;
  totalSlides = 5;
  modalContent = content.Data.v4_rcc_root.content.introductionModal;
  commonContent = content.Data.v4_rcc_root.content.common;

  constructor(
    private readonly contentService: ContentService,
    private gatekeeperService: GatekeeperService,
    private persistentStorage: PersistentStorageService,
  ) {}

  ngOnInit(): void {
    this.activeSlide = 0;
    this.contentService.getContent().subscribe((data) => {
      this.modalContent = data.Data.v4_rcc_root.content.introductionModal;
      this.commonContent = data.Data.v4_rcc_root.content.common;
    });

    if (!this.gatekeeperService.getToggleValue('rcc_introduction_modal')) {
      this.showModal = false;
      return;
    }

    this.showModal = this.shouldShowModal();
    if (this.showModal) {
      setTimeout(() => this.openModal(), 0);
    }
  }

  openModal(): void {
    const modalElement = this.modal?.nativeElement as ModalFunctions | undefined;
    const dialogElement = this.dialog?.nativeElement as HTMLDialogElement | undefined;

    if (!modalElement || !dialogElement) {
      setTimeout(() => this.openModal(), 0);
      return;
    }

    modalElement.proxyShowModal();
    dialogElement.addEventListener(
      'close',
      () => {
        this.onModalClosed();
      },
      { once: true },
    );
  }

  goToSlide(index: number): void {
    if (index >= 0 && index < this.totalSlides) {
      this.activeSlide = index;
    }
  }

  closeModal(): void {
    if (!this.showModal) {
      return;
    }
    (this.modal.nativeElement as ModalFunctions).proxyClose();
  }

  useTool(): void {
    if (!this.showModal) {
      return;
    }
    (this.modal.nativeElement as ModalFunctions).proxyClose();
  }

  private onModalClosed(): void {
    this.setCookie();
    this.showModal = false;
  }

  private shouldShowModal(): boolean {
    const cookieValue = this.persistentStorage.getCookieJSON(this.cookieName)?.[this.flagName];

    if (cookieValue === true) {
      this.setCookie();
      return false;
    }

    return true;
  }

  private setCookie(): void {
    this.persistentStorage.setCookieJSON(this.cookieName, this.flagName, true, 30);
  }
}
